import { useState, useCallback } from 'react';

export const useToastHook = (position = 'top-end') => {
  const [toast, setToast] = useState({ show: false, message: '', color: '', position });

  const handleToastState = useCallback(
    (message = '', color = 'success', toastPosition = 'top-end', duration = 2500) => {
      setToast((prevState) => {
        if (typeof message === 'string' && message.length > 0) {
          return { show: true, message, color, position: toastPosition, duration };
        }
        return { ...prevState, show: false };
      });
    },
    []
  );

  return { toast, handleToastState };
};
